const e = up.element;
const u = up.util;
up.RevealMotion = class RevealMotion {
    constructor(element, options = {}) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
        this._element = element;
        this._viewport = e.get(options.viewport) || up.viewport.get(this._element);
        this._obstructionsLayer = up.layer.get(this._viewport);
        this._behavior = (_b = (_a = options.scrollBehavior) !== null && _a !== void 0 ? _a : options.behavior) !== null && _b !== void 0 ? _b : 'instant';
        const viewportConfig = up.viewport.config;
        this._snap = (_d = (_c = options.snap) !== null && _c !== void 0 ? _c : options.revealSnap) !== null && _d !== void 0 ? _d : viewportConfig.revealSnap;
        this._padding = (_f = (_e = options.padding) !== null && _e !== void 0 ? _e : options.revealPadding) !== null && _f !== void 0 ? _f : viewportConfig.revealPadding;
        this._top = (_h = (_g = options.top) !== null && _g !== void 0 ? _g : options.revealTop) !== null && _h !== void 0 ? _h : viewportConfig.revealTop;
        this._max = (_k = (_j = options.max) !== null && _j !== void 0 ? _j : options.revealMax) !== null && _k !== void 0 ? _k : viewportConfig.revealMax;
        this._topObstructionSelector = viewportConfig.selector('fixedTopSelectors');
        this._bottomObstructionSelector = viewportConfig.selector('fixedBottomSelectors');
    }
    start() {
        const viewportRect = this._getViewportRect(this._viewport);
        const elementRect = up.Rect.fromElement(this._element);
        if (this._max) {
            const maxPixels = u.evalOption(this._max, this._element);
            elementRect.height = Math.min(elementRect.height, maxPixels);
        }
        elementRect.grow(this._padding);
        this._substractObstructions(viewportRect);
        if (viewportRect.height < 0) {
            up.fail('Viewport has no visible area');
        }
        const originalScrollTop = this._viewport.scrollTop;
        let newScrollTop = originalScrollTop;
        if (this._top || (elementRect.height > viewportRect.height)) {
            const diff = elementRect.top - viewportRect.top;
            newScrollTop += diff;
        }
        else if (elementRect.top < viewportRect.top) {
            newScrollTop -= (viewportRect.top - elementRect.top);
        }
        else if (elementRect.bottom > viewportRect.bottom) {
            newScrollTop += (elementRect.bottom - viewportRect.bottom);
        }
        else {
        }
        if (u.isNumber(this._snap) && (newScrollTop < this._snap) && (elementRect.top < (0.5 * viewportRect.height))) {
            newScrollTop = 0;
        }
        if (newScrollTop !== originalScrollTop) {
            this._viewport.scrollTo({ top: newScrollTop, behavior: this._behavior });
        }
    }
    _getViewportRect() {
        if (up.viewport.isRoot(this._viewport)) {
            return new up.Rect({
                left: 0,
                top: 0,
                width: up.viewport.rootWidth(),
                height: up.viewport.rootHeight()
            });
        }
        else {
            return up.Rect.fromElement(this._viewport);
        }
    }
    _computeObstructionRects(selector) {
        let elements = up.fragment.all(selector, { layer: this._obstructionsLayer });
        elements = u.filter(elements, e.isVisible);
        return u.map(elements, (element) => {
            if (e.style(element, 'position') === 'sticky') {
                return up.Rect.fromElementAsFixed(element);
            }
            else {
                return up.Rect.fromElement(element);
            }
        });
    }
    _substractObstructions(viewportRect) {
        for (let obstructionRect of this._computeObstructionRects(this._topObstructionSelector)) {
            let diff = obstructionRect.bottom - viewportRect.top;
            if (diff > 0) {
                viewportRect.top += diff;
                viewportRect.height -= diff;
            }
        }
        for (let obstructionRect of this._computeObstructionRects(this._bottomObstructionSelector)) {
            let diff = viewportRect.bottom - obstructionRect.top;
            if (diff > 0) {
                viewportRect.height -= diff;
            }
        }
    }
};
